// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__rNrub","total":"Cart_total__uUmfv","actions":"Cart_actions__z5eCh","button--alt":"Cart_button--alt__uJPQC","button":"Cart_button__eT95q"};